var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-navTab"},[_c('b-tabs',{model:{value:(_vm.tabindex),callback:function ($$v) {_vm.tabindex=$$v},expression:"tabindex"}},_vm._l((_vm.items),function(item,index){return _c('b-tab',{key:index,attrs:{"title":item.title},on:{"click":function($event){return _vm.clickTab(item)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }